import { ActionTable } from "../../ActionTable/ActionTable";
import LicenseModelsFilter from "../LicenseModelsFilter";
import dateFnsFormat from 'date-fns/format';
import { useCallback, useEffect, useState } from "react";
import { listLicenseTypes } from "../../../services/service";
import BtnAddLicense from "../BtnAddLicense";
import BtnAddLicenseType from "../BtnAddLicenseType";
import EditLicenseModel from "../EditLicenseModel";
import DeleteLicense from "../DeleteLicense";
import { parseDurationVerbose } from "../../../services/utils";
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from '@mui/material/Button';
import { styled } from '@mui/material/styles';
import { blue } from '@material-ui/core/colors/';
import InsertLinkIcon from '@mui/icons-material/InsertLink';
import { Box } from '@mui/material';

const defaultResponse = {
  count: 0, results: [], next: null, previous: null
}

const ColorButton = styled(Button)(({ theme }) => ({
  color: 'white',
  backgroundColor: blue[700],
  '&:hover': {
    backgroundColor: blue[900],
  },
}));

export default function LicenseModels(props) {
  const { tabIndex } = props;
  const [loading, setLoading] = useState(true);
  const [editModal, setEditModal] = useState(false);
  const [licensesData, setLicensesData] = useState(defaultResponse);
  const [licenseData, setLicenseData] = useState({});
  const [deleteModal, setDeleteModal] = useState(false);
  const [currentLicensePage, setCurrentLicensePage] = useState(0);
  const [currentLicensePageSize, setCurrentLicensePageSize] = useState(25);
  const [LinkModal, setLinkModal] = useState(false)
  const [choseLicenseData, setChoseLicense] = useState(false)
  const [licenseFilters, setLicenseFilters] = useState({
    expand: "license_type,company",
  })

  const licenseColumnsMap = {
    id: "ID",
    name: "Nome",
    duration_verbose: "Duração",
    types_verbose: "Produtos",
    max_tags: "Máximo de Tags",
    max_control_loops: "Máximo de Malhas de Controle",
    created_at: "Data de Criação",
  }


  const licenseTypeMap = {
    historian: "Historian",
    pid: "PID",
    aiot: "AIoT"
  }

  const licenseTypeParser = (types) => {
    var verboseNameArray = types.map(el => licenseTypeMap[el])
    var verboseTypes = ""
    if (verboseNameArray.length === 2) {
      verboseTypes = verboseNameArray.join(" & ")
    } else if (verboseNameArray.length >= 3) {
      var arr1 = verboseNameArray.slice(0, 2).join(", ")
      var arr2 = verboseNameArray.slice(-1)
      verboseTypes = [arr1, arr2].join(" & ")
    } else {
      verboseTypes = verboseNameArray[0]
    }
    return verboseTypes
  }


  const handleLicenseEdit = (valueData) => {
    setEditModal(true)
    setLicenseData(valueData)
  }

  const handleLicenseDelete = (valueModel) => {
    setDeleteModal(true)
    setLicenseData(valueModel)
  }

  const parseLicenseData = (data) => {
    data.results.map((el) => {
      el["duration_verbose"] = parseDurationVerbose(el.duration)
      el["created_at"] = dateFnsFormat(new Date(el.created_at), 'dd/MM/yy HH:mm')
      el["types_verbose"] = licenseTypeParser(el.types)
      if (!el.config) {
        el["max_tags"] = "N/A"
        el["max_control_loops"] = "N/A"
      } else {
        el["max_tags"] = !el.config.historian ? "N/A" : !!el.config.historian.max_tags ? el.config.historian.max_tags : "∞"
        el["max_control_loops"] = !el.config.pid ? "N/A" : !!el.config.pid.max_control_loops ? el.config.pid.max_control_loops : "∞"
      }
      return el
    })
    console.log(data)
    setLicensesData(data)
  }

  const listLicensesFn = useCallback(() => {
    setLoading(true);
    listLicenseTypes(currentLicensePage + 1, currentLicensePageSize, licenseFilters)
      .then((response) => {
        parseLicenseData(response.data)
        console.log(response.data)
      })
      .catch((error) => {
        // TODO: Add an alert notifying the user about this error.
        console.log(error)
      })
      .finally(setLoading(false))
  }, [currentLicensePage, currentLicensePageSize, tabIndex])


  useEffect(() => {
    listLicensesFn()
  }, [listLicensesFn])


  const onLicenseChanged = (licenseData) => {
    listLicensesFn()
  }

  const onPageChange = (newPage) => {
    setCurrentLicensePage(newPage)
  }

  const onPageSizeChange = (newPageSize) => {
    setCurrentLicensePage(0)
    setCurrentLicensePageSize(newPageSize)
  }

  const handleSeeMoreLicense = (valueData) => {
    setLicenseData(valueData)
    window.open(`/license-types/${valueData.id}`, '_blank')
  }
  return (
    <Row>
      <EditLicenseModel
        openModal={editModal}
        setOpenModal={setEditModal}
        licenseTypeData={licenseData}
        onLicenseChanged={onLicenseChanged}
        sx={{ marginTop: 1 }}
      />
      <DeleteLicense
        openModal={deleteModal}
        setOpenModal={setDeleteModal}
        licenseData={licenseData}
        onLicenseChanged={onLicenseChanged}
      />
      <Col lg={9}>
        <LicenseModelsFilter
          pageSize={currentLicensePageSize}
          setLicensesData={parseLicenseData}
          loading={loading}
          setLoading={setLoading}
          setFilters={setLicenseFilters}
        />
        <ActionTable
          title="Modelos de Licença"
          enableCheck
          currentPage={currentLicensePage}
          pageSize={currentLicensePageSize}
          pageSizeOptions={licensesData.count < 10 ? [10]
            : licensesData.count < 25
              ? [10, 25]
              : [10, 25, 40]
          }
          count={licensesData.count}
          columns={Object.keys(licenseColumnsMap)}
          columnsMap={licenseColumnsMap}
          rows={licensesData.results}
          onPageChange={onPageChange}
          onPageSizeChange={onPageSizeChange}
          onEditSelected={handleLicenseEdit}
          onDeleteSelected={handleLicenseDelete}
          onSeeMoreLicense={handleSeeMoreLicense}
          setLinkLicenseIcon={false}
          setSeeMoreLicenseIcon={true}
        />
      </Col>
      <Col lg={3}>
        <Row>
          <BtnAddLicense onLicenseCreated={onLicenseChanged} />
          <BtnAddLicenseType
            sx={{ marginTop: 1 }}
            onLicenseCreated={onLicenseChanged}
          />
          <Box sx={{ marginTop: 1 }}>
            <ColorButton
              sx={{ padding: 2, width: "100%" }}
              startIcon={<InsertLinkIcon />}
              onClick={() => [
                setLinkModal(true), setChoseLicense(true)]}>
              Vincular Hardware
            </ColorButton>
          </Box>
        </Row>
      </Col >
    </Row >
  )
}
